// extracted by mini-css-extract-plugin
export var chevron = "Accordion-module--chevron--db0ab";
export var control = "Accordion-module--control--afc71";
export var item = "Accordion-module--item--3b88a";
export var root = "Accordion-module--root--9e5fb";